/**
 * @flow
 * @relayHash 86ec19d7080782e7b4766aebaa91975b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentsForReviewCSVQueryVariables = {|
  justMine?: ?boolean
|};
export type DocumentsForReviewCSVQueryResponse = {|
  +documentsToReviewCsv: ?{|
    +taskId: ?string
  |}
|};
export type DocumentsForReviewCSVQuery = {|
  variables: DocumentsForReviewCSVQueryVariables,
  response: DocumentsForReviewCSVQueryResponse,
|};
*/


/*
query DocumentsForReviewCSVQuery(
  $justMine: Boolean
) {
  documentsToReviewCsv(justMine: $justMine) {
    taskId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "justMine",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "documentsToReviewCsv",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "justMine",
        "variableName": "justMine",
        "type": "Boolean"
      }
    ],
    "concreteType": "CSVTaskResult",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "taskId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DocumentsForReviewCSVQuery",
  "id": "fc5ce8c6dd5aa49dbd178b25f608acd3",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DocumentsForReviewCSVQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "DocumentsForReviewCSVQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "query DocumentsForReviewCSVQuery(\n  $justMine: Boolean\n) {\n  documentsToReviewCsv(justMine: $justMine) {\n    taskId\n  }\n}\n";
(node/*: any*/).hash = 'decfdd5231e5b9e22e68c616fdece2d4';
module.exports = node;
